import { render, staticRenderFns } from "./wol.vue?vue&type=template&id=4b8e3d4e&scoped=true&lang=pug&"
import script from "./wol.vue?vue&type=script&lang=js&"
export * from "./wol.vue?vue&type=script&lang=js&"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=4b8e3d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e3d4e",
  null
  
)

export default component.exports